<template>
  <section class="dida-module-header" aria-label="道旅生产运营导航">
    <div class="dida-module-header__hero">
      <div class="dida-module-header__copy">
        <div class="dida-module-header__eyebrow">道旅生产运营中心</div>
        <h1>{{ title }}</h1>
        <p>{{ description }}</p>
      </div>
      <div class="dida-module-header__runtime">
        <el-tag :type="tagType" effect="dark" size="small">
          <i :class="statusIcon" /> {{ statusText }}
        </el-tag>
        <span v-if="updatedAt" class="dida-module-header__updated">最近刷新：{{ updatedAt }}</span>
        <span v-if="autoRefreshText" class="dida-module-header__updated">{{ autoRefreshText }}</span>
        <el-button
          v-if="refreshable"
          size="mini"
          icon="el-icon-refresh"
          :loading="loading"
          @click="$emit('refresh')"
        >刷新当前页</el-button>
      </div>
    </div>

    <nav class="dida-module-header__nav" aria-label="道旅模块功能">
      <router-link
        v-for="item in navigation"
        :key="item.path"
        :to="item.path"
        class="dida-module-header__nav-item"
        :class="{ 'is-active': activePath === item.path }"
      >
        <i :class="item.icon" />
        <span>{{ item.label }}</span>
      </router-link>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'DidaModuleHeader',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    status: { type: String, default: 'healthy' },
    statusText: { type: String, default: '运行正常' },
    updatedAt: { type: String, default: '' },
    autoRefreshText: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    refreshable: { type: Boolean, default: true },
  },
  data() {
    return {
      navigation: [
        { path: '/dida/overview', label: '运营总览', icon: 'el-icon-monitor' },
        { path: '/dida/hotel-publish-controls', label: '资源发布', icon: 'el-icon-office-building' },
        { path: '/dida/activity-rates', label: '活动价核对', icon: 'el-icon-price-tag' },
        { path: '/dida/push-monitor', label: '推送时效', icon: 'el-icon-data-line' },
        { path: '/dida/worker-controls', label: '并发与积压', icon: 'el-icon-cpu' },
        { path: '/dida/order-monitor', label: '订单链路', icon: 'el-icon-connection' },
        { path: '/dida/booking-logs', label: 'Booking日志', icon: 'el-icon-document' },
        { path: '/dida/hotel-mappings', label: '酒店映射', icon: 'el-icon-map-location' },
      ],
    }
  },
  computed: {
    activePath() {
      return this.$route && this.$route.path ? this.$route.path : ''
    },
    tagType() {
      return { healthy: 'success', loading: 'info', warning: 'warning', danger: 'danger' }[this.status] || 'info'
    },
    statusIcon() {
      return this.status === 'healthy' ? 'el-icon-success' : (this.status === 'loading' ? 'el-icon-loading' : 'el-icon-warning')
    },
  },
}
</script>

<style lang="scss" scoped>
.dida-module-header {
  margin: -4px 0 18px;
  overflow: hidden;
  border: 1px solid #d9e5f5;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(31, 45, 61, .06);
}
.dida-module-header__hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 20px 22px;
  color: #fff;
  background: linear-gradient(120deg, #173a67 0%, #2469a5 58%, #2f86c7 100%);
}
.dida-module-header__copy { min-width: 0; }
.dida-module-header__eyebrow { margin-bottom: 6px; color: #bcdcff; font-size: 12px; letter-spacing: 2px; }
.dida-module-header h1 { margin: 0; font-size: 24px; line-height: 32px; }
.dida-module-header p { max-width: 860px; margin: 6px 0 0; color: #d9ebfb; font-size: 13px; line-height: 20px; }
.dida-module-header__runtime { display: flex; align-items: center; justify-content: flex-end; gap: 10px; flex-wrap: wrap; min-width: 260px; }
.dida-module-header__runtime ::v-deep .el-button { color: #164e7e; border-color: rgba(255, 255, 255, .8); background: #fff; }
.dida-module-header__updated { color: #d9ebfb; font-size: 12px; white-space: nowrap; }
.dida-module-header__nav { display: grid; grid-template-columns: repeat(8, minmax(105px, 1fr)); padding: 0 10px; background: #fff; }
.dida-module-header__nav-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 48px;
  color: #606266;
  font-size: 13px;
  text-decoration: none;
  transition: color .2s, background .2s;
}
.dida-module-header__nav-item:hover { color: #2f86c7; background: #f4f9fe; }
.dida-module-header__nav-item.is-active { color: #1768a5; font-weight: 600; background: #edf6fd; }
.dida-module-header__nav-item.is-active::after { position: absolute; right: 18px; bottom: 0; left: 18px; height: 3px; content: ''; border-radius: 3px 3px 0 0; background: #2f86c7; }
@media (max-width: 1200px) {
  .dida-module-header__hero { align-items: flex-start; flex-direction: column; }
  .dida-module-header__runtime { justify-content: flex-start; min-width: 0; }
  .dida-module-header__nav { grid-template-columns: repeat(4, 1fr); }
}
@media (max-width: 600px) {
  .dida-module-header__hero { padding: 16px; }
  .dida-module-header h1 { font-size: 20px; }
  .dida-module-header__nav { grid-template-columns: repeat(2, 1fr); padding: 0; }
  .dida-module-header__nav-item { min-height: 44px; }
}
</style>
